// @flow
import * as React from 'react'
import 'ta-semantic-ui/semantic/dist/components/card.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import 'ta-semantic-ui/semantic/dist/components/label.css'
import 'ta-semantic-ui/semantic/dist/components/header.css'
import './styles.scss'
import { Property } from 'components/property'
import { TopImage } from 'components/topImage/component'
import { Stars } from 'components/stars'
import { Link } from '@ta-interaktiv/contentbricks'

type Props = {
  address: string,
  category: string,
  className: string,
  description: string,
  host: string,
  image: string,
  winnerText: string,
  name: string,
  phone: string,
  previousRank: string,
  price: string,
  rank: number,
  stars: number,
  typeOfStay: string,
  website: string
}

export function Hotel({
  stars,
  website,
  category,
  image,
  winnerText,
  rank,
  previousRank,
  name,
  description,
  address,
  phone,
  host,
  typeOfStay,
  price,
  className = ''
}: Props) {
  // we're totally using array destructuring here, how fancy!
  const [hotelName, place] = name.split(', ')

  return (
    <a
      href={`http://${website}`}
      className={`ui link hotel ${className} card`}
      style={{ position: 'relative' }}
    >
      <TopImage
        current={rank}
        previous={previousRank}
        category={category}
        imageName={image}
      />

      <div className='content'>
        <h3 className={`ui ${+rank >= 11 ? 'small' : ''} header`}>
          {hotelName} <Stars amount={stars} />
        </h3>
        <h4 className='meta sub header'>{description}</h4>
        <p className='winner ta text mobile only'>{winnerText}</p>
      </div>

      <table className='ui fixed small very compact definition attached unstackable striped table'>
        <tbody>
          <Property keyName='Adresse'>
            {address.split(', ')[0]}
            <br />
            {address.split(', ')[1]}
          </Property>

          <Property keyName='Telefon'>{phone}</Property>

          <Property keyName='Website'>
            <Link href={`http://${website}`} target='_blank'>{website.replace('www.', '')}</Link>
          </Property>

          {host !== '' && <Property keyName='Gastgeber'>{host}</Property>}

          <Property keyName={typeOfStay}>{price}</Property>
        </tbody>
      </table>
    </a>
  )
}

export default Hotel
